import { lazy } from 'react';

// project-imports
import Loadable from 'components/Loadable';
import AuthLayout from 'layout/Auth';

// Vektra auth screens — paths mirror vektra-client-deprecated/app/auth/*.
const Login = Loadable(lazy(() => import('pages/vektra/auth/login')));
const SelectAccount = Loadable(lazy(() => import('pages/vektra/auth/select-account')));
const VerifyOtp = Loadable(lazy(() => import('pages/vektra/auth/verify-otp')));
const SetPasswordPage = Loadable(lazy(() => import('pages/vektra/auth/set-password')));
const ImpersonateQrLanding = Loadable(lazy(() => import('pages/vektra/auth/impersonate-qr')));

const LoginRoutes = {
  path: '/auth',
  element: <AuthLayout />,
  children: [
    { path: 'login', element: <Login /> },
    { path: 'select-account', element: <SelectAccount /> },
    { path: 'verify-otp', element: <VerifyOtp /> },
    { path: 'set-password', element: <SetPasswordPage /> },
    { path: 'qr', element: <ImpersonateQrLanding /> }
  ]
};

export default LoginRoutes;
